import YoutubeComponent from "./YoutubeComponent";
import {Typography} from "antd";

export default function Tutorial() {
    return (
        <>
            <Typography.Title level={3}>
                RAS Review Basics
            </Typography.Title>
            <YoutubeComponent
                width={640}
                height={480}
                speed={1.5}
                src={'https://www.youtube.com/embed/0oQZS-b8jXk'}
            />
            <br />
            <br />
            <Typography.Title level={3}>
                How to Prepare the Output text file?
            </Typography.Title>
            <YoutubeComponent
                width={640}
                height={360}
                speed={1.5}
                src={'https://www.youtube.com/embed/ROzov7XibQ0'}
            />
        </>
    )
}